import { Battery, BatteryLow, BatteryWarning, HelpCircle } from "lucide-react";
import { cn } from "@/lib/utils";

// Bouncie's OBD-II hardware never streams a battery percentage over REST —
// the signal is their `battery` webhook event, fired when voltage crosses one
// of their thresholds (12.6V normal, 12V low, 11.5V critical). Those three
// map straight onto good/low/critical here. "unknown" is only for a vehicle
// whose device has never reported at all; a live device that has sent no
// battery event is "good", which is what Bouncie's own app shows. Never
// render a numeric % here — see backend/app/api/serializers.py.
const CONFIG = {
  good: { label: "Battery Good", icon: Battery, className: "text-emerald-400" },
  low: { label: "Battery Low", icon: BatteryLow, className: "text-amber-400" },
  critical: { label: "Battery Critical", icon: BatteryWarning, className: "text-red-400" },
  unknown: { label: "Battery Unknown", icon: HelpCircle, className: "text-muted-foreground" },
};

export function BatteryStatus({ status, className, compact = false }) {
  const cfg = CONFIG[status] || CONFIG.unknown;
  const Icon = cfg.icon;
  return (
    <div className={cn("flex items-center gap-1.5", cfg.className, className)}>
      <Icon className="h-3.5 w-3.5 shrink-0" />
      <span className="text-sm">{compact ? cfg.label.replace("Battery ", "") : cfg.label}</span>
    </div>
  );
}
